export const version = "random/5.6.0";
